<div>
  <div class="d-flex justify-content-between">
    <label translate>FROM</label>
    <a *ngIf="showTodayDate" (click)="selectTodayMinDate()" translate>TODAY</a>
  </div>
  <div class="input-group mb-2">
    <input class="form-control" ngbDatepicker [(ngModel)]="minDate" #minDp="ngbDatepicker" (ngModelChange)="emitDateTimeRange()" (dateSelect)="emitDateTimeRange()" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" (click)="minDp.toggle()" type="button">
        <i class="fal fa-calendar-alt"></i>
      </button>
    </div>
  </div>
  <div class="d-flex mb-2">
    <input type="number" class="form-control" [(ngModel)]="minHour" min="0" max="23" placeholder="0" (input)="validateHour('min')" (change)="emitDateTimeRange()" placeholder="HH">
    <span class="mx-1">:</span>
    <input type="number" class="form-control" [(ngModel)]="minMinute" min="0" max="59" placeholder="0" (input)="validateMinute('min')" (change)="emitDateTimeRange()" placeholder="MM">
  </div>

  <div class="d-flex justify-content-between">
    <label translate>TO</label>
    <a *ngIf="showTodayDate" (click)="selectTodayMaxDate()" translate>TODAY</a>
  </div>
  <div class="input-group mb-2">
    <input class="form-control" ngbDatepicker [(ngModel)]="maxDate" #maxDp="ngbDatepicker" (ngModelChange)="emitDateTimeRange()" (dateSelect)="emitDateTimeRange()" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" (click)="maxDp.toggle()" type="button">
        <i class="fal fa-calendar-alt"></i>
      </button>
    </div>
  </div>
  <div class="d-flex mb-2">
    <input type="number" class="form-control" [(ngModel)]="maxHour" min="0" max="23" placeholder="0" (input)="validateHour('max')" (change)="emitDateTimeRange()" placeholder="HH">
    <span class="mx-1">:</span>
    <input type="number" class="form-control" [(ngModel)]="maxMinute" min="0" max="59" placeholder="0" (input)="validateMinute('max')" (change)="emitDateTimeRange()" placeholder="MM">
  </div>
</div>
